<template>
  <div :class="$style['tutorials-tab-wrapper']">
    <div
      v-if="filteredVideos.length"
      :class="[$style['tutorials-list'], showTopGradient ? $style.haze : '']"
    >
      <div
        ref="tutorialsList"
        :class="$style['tutorials-list-scroll']"
        class="gantt_scroll"
        @scroll="handleScroll"
      >
  <div :class="$style.tutorials_tab">
          <learning-center-video-card
            v-for="video in filteredVideos"
            :key="video.id"
            :video="video"
            @open-video="$emit('open-video', $event)"
    />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getVideoTutorials } from '../../../../videoTutorials';
import LearningCenterVideoCard from './learningCenterVideoCard.vue';

export default {
  name: 'LearningCenterTutorialsTab',
  components: {
    LearningCenterVideoCard,
  },
  emits: ['open-video'],
  props: {
    searchQuery: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      videos: getVideoTutorials(window.user?.locale || 'en'),
      showTopGradient: false,
    };
  },
  mounted() {
    this.$nextTick(() => {
      const list = this.$refs.tutorialsList;
      if (list) {
        this.showTopGradient = list.scrollTop > 0;
      }
    });
  },
  computed: {
    filteredVideos() {
      return this.videos;
    },
  },
  methods: {
    handleScroll(event) {
      const target = event.target;
      this.showTopGradient = target.scrollTop > 0;
    },
  },
};
</script>

<style module lang="less">
@import "../../../../../../less/_variables.less";
@import "../../../../../../less/_mixins.less";

.tutorials-tab-wrapper {
  width: 100%;
  height: 100%;
  padding-right: 4px;
  display: flex;
  flex-direction: column;
  position: relative;
}

.tutorials-list {
  position: relative;
  display: flex;
  flex: 1;
  min-height: 0;
  flex-direction: column;

  &:before {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    height: 56px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%);
    pointer-events: none;
    opacity: 0;
    transition: 0.2s ease opacity;
    z-index: 1;
  }

  &.haze {
    &:before {
      opacity: 1;
    }
  }
}

.tutorials-list-scroll {
  display: flex;
  flex: 1;
  min-height: 0;
  flex-direction: column;
  overflow-y: auto;
  padding-right: 20px;
  scrollbar-gutter: stable;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #BBBBBB;
    border-radius: 2px;

    &:hover {
      background: #999999;
    }
  }
}

.tutorials_tab {
  display: grid;
  grid-template-columns: repeat(3, 208px);
  gap: 20px;
  padding-bottom: 20px;
//   margin: 0 auto;
  max-width: 664px;
  box-sizing: border-box;
}
</style>

